import { FC, memo } from 'react'
// import { Box } from '@chakra-ui/react'
import { createIcon } from '@chakra-ui/icons'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'

const FolderEditOutline = createIcon({
  displayName: 'FolderEditOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M17.146 20.707l3.56-3.56c.391-.391.391-1.024 0-1.414l-1.586-1.586c-.391-.391-1.024-.391-1.414 0l-3.56 3.56c-.188.188-.293.442-.293.707v2.586h2.586c.265 0 .519-.105.707-.293Z"></path>
        <path d="M21 11v-3.06c0-1.104-.895-2-2-2h-6.471c-.331 0-.641-.164-.827-.438l-1.405-2.065c-.186-.273-.495-.437-.826-.437h-4.471c-1.105 0-2 .895-2 2v12c0 1.105.895 2 2 2h5"></path>
      </g>
      <path fill="none" d="M0 0h24v24h-24v-24Z"></path>
    </>
  ),
})

const FolderEdit: FC<CustomIconProps> = (props) => {
  // if (props.variant === 'twoTone') return <CustomIcon as={FolderEditTwoTone} {...props} />

  return <CustomIcon as={FolderEditOutline} {...props} />
}

export default memo(FolderEdit)
